export const capitalise = (word) => {
    return `${word[0].toUpperCase()}${word.substring(1).toLowerCase()}`;
};
export const capitaliseWords = (string) => {
    return string.split(' ').map(capitalise).join(' ');
};
export const getAcronymFromString = (string = '') => {
    return string
        .split(' ')
        .map((word) => word.slice(0, 1))
        .join('');
};
